import {
  createSpanName,
  SpanComponent,
  instrument,
} from '@imprivata-cloud/common';
import type { OrgPreferences } from '@imprivata-cloud/authn';
import { client } from './client';
import getConfigs from '../appConfigUtils';

const { API_URL } = getConfigs();

export const getOrgPreferences = instrument(
  createSpanName(SpanComponent.UI, 'service', 'getOrgPreferences'),
  async (): Promise<OrgPreferences> => {
    return client.post<OrgPreferences, OrgPreferences>(
      `${API_URL}/authn-web/org-preferences/v2/org-preferences/get`,
    );
  },
);
